import React from 'react';
import { componentService } from 'js/services/component.service';

export const SportsbookBalance = React.lazy(() => import(/* webpackChunkName: "sportsbook-balance" */ './SportsbookBalance'));

// <hub2-sportsbook-balance type="sportsTotal"></hub2-sportsbook-balance>
componentService.registerWebContentComponents({ SportsbookBalance });
